// Homepage copy for the About, Process and FAQ sections.

export const bio = {
	image: "shelby-about.jpg",
	paragraphs: [
		"I absolutely love everything flowers! I got my start at the cutest little flower shop, where I trained as a designer and fell in love with floral design. I've been creating ever since, taking pride in every little detail!",
		"One of my favorite parts of what I do is getting to know my couples and bringing their wedding visions to life. I love creating flowers that feel personal to you and add beauty to your special day, becoming memories you'll cherish in photos for years to come!",
	],
};

export const processSteps = [
	{
		title: "Inquire",
		body: "Tell us about your day using the form below. We'll be in touch within 48 hours.",
	},
	{
		title: "Design",
		body: "We talk through your vision, colors and inspiration, then put together a custom proposal for your florals.",
	},
	{
		title: "Celebrate",
		body: "We bring it all to life so your flowers are one less thing to think about on your day.",
	},
];

export const faqs = [
	{
		q: "How does pricing work?",
		a: "We talk through your vision, colors and inspiration, then put together a custom proposal for your florals.",
	},
	{
		q: "Do you only do weddings?",
		a: "We specialize in weddings and events.",
	},
	{
		q: "How do I secure my date?",
		a: "To secure your date, a signed contract and deposit are required. The deposit is applied toward your total investment and officially reserves your date with Shelby Floral. Dates are filling up quickly for 2027!",
	},
	{
		q: "Do you handle delivery, setup, and breakdown?",
		a: "Yes. Shelby Floral handles delivery, full setup and optional breakdown and repurposing.",
	},
];
